import "@aws-amplify/ui-react/styles.css";
import "antd/dist/reset.css";
import { Crisp } from "crisp-sdk-web";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { AppRouter } from "./components/AppRouter/AppRouter";
import TopBarProgress from "react-topbar-progress-indicator";

Crisp.configure("cb65408e-e55f-46ee-9e3f-c1956659e90b", {
  autoload: false,
});

TopBarProgress.config({
  barColors: {
    "0": "#0e4206",
    "1.0": "#0e4206",
  },
  barThickness: 5,
  shadowBlur: 2,
});

const App = () => {
  return <RouterProvider router={AppRouter} />;
};

export default App;
